import styled from 'styled-components';
import GameHeader from './componant/GameHeader';
import Footer from '../components/footer/Footer';
import FullLanking from './componant/FullLanking';
import { useState, useEffect } from 'react';
import Myhistory from './componant/MyHistory';
import GameService from '../../service/game/GameService';
import { useParams, useNavigate } from 'react-router-dom';
import InterestService from '../../service/Interest';
import { isLogin } from '../../utils/auth';
import AddInterestItemModal from '../components/modal/AddInterestItem';
import { useModal } from '../../context/ModalContext';
import UserAlert from '../components/userAlert/UserAlert';
import Toast from './componant/Toast';

interface Params {
  gameId: string;
  playId: string;
  playerId: string;
}

type Game = {
  game_id: number;
  title: string;
  description: string;
  bracket_size: number;
};

const GameResult = () => {
  const { gameId, playId, playerId } = useParams() as unknown as Params;
  const navigate = useNavigate();

  const parsedGameId = Number(gameId);
  const parsedPlayId = Number(playId);

  const [resultItems, setResultItems] = useState<any[]>([]);
  const [activeStartIndex, setActiveStartIndex] = useState<number | null>(null);
  const [active, setActive] = useState({
    start: false,
    lank: false,
    share: false,
  });
  const [showLikeModal, setShowLikeModal] = useState(false);
  const [selectedIdx, setSelectedIdx] = useState<number | null>(null);
  const { modalDispatch } = useModal();
  const [gameInfo, setGameInfo] = useState<Game | null>(null);

  useEffect(() => {
    if (!parsedGameId || !parsedPlayId || !playerId) return;

    const fetchFinalWinnerItem = async () => {
      try {
        const allMatchesRes = await GameService.getMatch(
          parsedGameId,
          parsedPlayId,
          1,
          playerId,
        );
        const allMatches = allMatchesRes?.data || [];

        if (allMatches.length === 0) return;

        const totalMatchCount = allMatches.length;
        const totalItems = totalMatchCount * 2;
        const lastRound = Math.log2(totalItems);

        const lastMatchRes = await GameService.getMatch(
          parsedGameId,
          parsedPlayId,
          lastRound,
          playerId,
        );
        const lastMatch = lastMatchRes?.data?.[0];
        if (!lastMatch) return;

        const { winner_item_id, left_item, right_item } = lastMatch;

        const winnerItem =
          left_item?.itemId === winner_item_id
            ? left_item
            : right_item?.itemId === winner_item_id
              ? right_item
              : null;

        if (winnerItem) {
          setResultItems([winnerItem]);
        }
      } catch (error) {
        console.error('[우승 물건 불러오기 실패]', error);
      }
    };

    fetchFinalWinnerItem();
  }, [parsedGameId, parsedPlayId, playerId]);

  const disLike = async (iidx: number) => {
    try {
      await InterestService.dislike(iidx);
      alert('관심물건에서 삭제되었습니다.');
      setResultItems((prev) =>
        prev.map((item) =>
          (item.iidx || item.itemId) === iidx
            ? { ...item, is_like: false }
            : item,
        ),
      );
    } catch (error) {
      console.error('관심물건 삭제 실패:', error);
      alert('관심물건 삭제 중 오류가 발생했습니다.');
    }
  };

  const formatKoreanWon = (amount: number | string) => {
    if (typeof amount === 'string') {
      amount = parseFloat(amount.replace(/,/g, ''));
    }
    if (typeof amount !== 'number' || isNaN(amount)) return '-';

    const isNegative = amount < 0;
    amount = Math.abs(amount);

    const units = [
      { value: 100000000, label: '억 ' },
      { value: 10000, label: '만' },
    ];

    let result = '';
    for (let unit of units) {
      if (amount >= unit.value) {
        const unitCount = Math.floor(amount / unit.value);
        amount %= unit.value;
        result += unitCount + unit.label;
      }
    }

    if (!result) result = amount.toLocaleString() + '원';
    return isNegative ? '-' + result : result;
  };
  const toggleLike = (iidx: number, liked: boolean) => {
    setResultItems((prev) =>
      prev.map((item) =>
        item.iidx === iidx ? { ...item, is_like: liked } : item,
      ),
    );
  };
  const handleShareGame = async (
    game: Game,
    playId: string | number,
    playerId: string | number,
  ) => {
    const shareData = {
      title: `경매 밸런스 게임: ${game.title}`,
      text: game.description,
      url: `${window.location.origin}/game/result/${game.game_id}/${playId}/${playerId}`,
    };

    const copyToClipboard = () => {
      navigator.clipboard.writeText(shareData.url).then(() => {
        Toast({
          description: '게임 링크가 클립보드에 복사되었습니다.',
          status: 'success',
        });
      });
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (err: any) {
        if (err.name !== 'AbortError') {
          console.log('Web Share API 실패, 클립보드로 대체');
          copyToClipboard();
        }
      }
    } else {
      copyToClipboard();
    }
  };
  useEffect(() => {
    const fetchGameInfo = async () => {
      try {
        const res = await GameService.list(1, 100);
        const game = res.data.list.find(
          (g: Game) => g.game_id === parsedGameId,
        );
        if (game) setGameInfo(game);
      } catch (e) {
        console.error('[게임 리스트에서 개별 게임 찾기 실패]', e);
      }
    };

    fetchGameInfo();
  }, [parsedGameId]);

  const [expandedRows, setExpandedRows] = useState<Set<string>>(new Set());
  const toggleExpand = (key: string) => {
    setExpandedRows((prev) => {
      const next = new Set(prev);
      next.has(key) ? next.delete(key) : next.add(key);
      return next;
    });
  };

  const renderTags = (tags: string[] = [], key: string, max: number) => {
    if (!tags.length) return null;

    const isExpanded = expandedRows.has(key);
    const visibleTags = isExpanded ? tags : tags.slice(0, max);
    const remainingCount = isExpanded ? 0 : Math.max(tags.length - max, 0);

    return (
      <>
        {visibleTags.map((tag, i) => {
          if (tag.startsWith('__STATUS__')) {
            return (
              <TagRed key={`${key}-${i}`}>
                {tag.replace('__STATUS__', '')}
              </TagRed>
            );
          }
          return tag.includes('대항력') ? (
            <TagBlue key={`${key}-${i}`}>{tag}</TagBlue>
          ) : (
            <TagGray key={`${key}-${i}`}>{tag}</TagGray>
          );
        })}

        {remainingCount > 0 && (
          <TagGray
            onClick={(e) => {
              e.stopPropagation();
              toggleExpand(key);
            }}
            style={{ cursor: 'pointer' }}
          >
            +{remainingCount}개
          </TagGray>
        )}
        {isExpanded && (
          <TagGray
            onClick={(e) => {
              e.stopPropagation();
              toggleExpand(key);
            }}
            style={{ cursor: 'pointer' }}
          >
            접기
          </TagGray>
        )}
      </>
    );
  };

  return (
    <Container>
      <GameHeader />
      <Content>
        <Inner>
          <TopBox>
            <img src="/assets/images/game/win_thropy.svg" />
            <img src="/assets/images/game/win_banner.svg" />

            <TopTitle>우승 물건</TopTitle>
            <TopText>최종 라운드에서 선택된 물건들을 확인하세요</TopText>
          </TopBox>

          <CardList>
            <BottomListWrap>
              {resultItems.map((card: any, index: number) => {
                const iidx = card.iidx || card.itemId;
                const isLiked = card.is_like;

                return (
                  <BottomList key={index}>
                    <BottomBox>
                      <BottomImg>
                        <img src={card.thumb} alt="썸네일" />
                      </BottomImg>
                      <Imgheart>
                        <img
                          src={`/assets/images/game/${isLiked ? 'heart_on' : 'heart_off'}.svg?v=${isLiked ? 1 : 0}`}
                          onClick={(e) => {
                            e.stopPropagation();

                            if (!iidx) {
                              alert('iidx 없음');
                              return;
                            }

                            if (!isLogin()) {
                              alert('로그인 후 이용해주세요.');
                              return;
                            }

                            if (isLiked) {
                              disLike(iidx);
                              toggleLike(iidx, false); //상태 업데이트
                            } else {
                              setSelectedIdx(iidx);
                              setShowLikeModal(true); // 모달 내에서 toggleLike(iidx, true) 호출 필요
                            }
                          }}
                          style={{ cursor: 'pointer' }}
                          alt="관심 등록 버튼"
                        />
                      </Imgheart>

                      <BottomInfo>
                        <StartBtn
                          className={activeStartIndex === index ? 'active' : ''}
                          onClick={() => {
                            if (!isLogin()) {
                              modalDispatch({
                                type: 'USER_ALERT',
                                payload: 'guest',
                              });
                              return;
                            }
                            setActiveStartIndex((prev) =>
                              prev === index ? null : index,
                            );
                            if (iidx) {
                              window.open(`/auction/detail/${iidx}`, '_blank');
                            }
                          }}
                        >
                          <div>자세히 보기</div>
                        </StartBtn>
                        <BottomInfoList>
                          <BottomInfoTitle>
                            <span>{card.category}</span>
                            {card.buildingName || card.address}
                          </BottomInfoTitle>
                          <BottomInfoText>
                            {card.address} ・ {card.buildingArea}㎡ (
                            {card.landArea}평)
                          </BottomInfoText>
                          <TagWrap>
                            {renderTags(
                              [
                                ...(card.status
                                  ? [`__STATUS__${card.status}`]
                                  : []),
                                ...(card?.tag ?? []),
                              ],
                              `${card.match_no}`,
                              3,
                            )}
                          </TagWrap>
                        </BottomInfoList>
                        <Description>
                          <DescriptionInfo>
                            <span>최저 입찰가</span>
                            <span className={!isLogin() ? 'blur' : ''}>
                              {formatKoreanWon(card.minPrice)}
                            </span>
                          </DescriptionInfo>
                          <DescriptionInfo>
                            <span>직전 실거래 매매가</span>
                            <span>
                              {isLogin()
                                ? formatKoreanWon(card.dealPrice)
                                : '로그인 후 확인 가능해요.'}
                              {!isLogin() && (
                                <LoginBtn
                                  onClick={() =>
                                    modalDispatch({
                                      type: 'USER_ALERT',
                                      payload: 'guest', // ModalContext에서 'guest' 모달 띄우도록 설정되어 있음
                                    })
                                  }
                                >
                                  로그인
                                </LoginBtn>
                              )}
                            </span>
                          </DescriptionInfo>
                          <DescriptionInfo>
                            <span>AI 추정가</span>
                            <span>
                              {isLogin()
                                ? formatKoreanWon(card.aiPrice)
                                : '로그인 후 확인 가능해요.'}
                              {!isLogin() && (
                                <LoginBtn
                                  onClick={() =>
                                    modalDispatch({
                                      type: 'USER_ALERT',
                                      payload: 'guest',
                                    })
                                  }
                                >
                                  로그인
                                </LoginBtn>
                              )}
                            </span>
                          </DescriptionInfo>
                        </Description>
                      </BottomInfo>
                    </BottomBox>
                  </BottomList>
                );
              })}
            </BottomListWrap>
          </CardList>
        </Inner>
      </Content>
      <FullLanking isLogin={isLogin} />
      <Myhistory
        gameId={parsedGameId}
        playId={parsedPlayId}
        playerId={playerId ?? ''}
      />
      <BtnWrap>
        <ShareBtn
          className={active.share ? 'active' : ''}
          onClick={() => {
            setActive((a) => ({ ...a, share: true }));

            if (gameInfo) {
              handleShareGame(gameInfo, playId, playerId);
            }

            setTimeout(() => {
              setActive((a) => ({ ...a, share: false }));
            }, 500);
          }}
        >
          <div>
            <img src="/assets/images/game/icon_share.svg" />
            게임 공유하기
          </div>
        </ShareBtn>
        <LankBtn
          className={active.lank ? 'active' : ''}
          onClick={() => {
            if (!isLogin()) {
              modalDispatch({
                type: 'USER_ALERT',
                payload: 'guest',
              });
              return;
            }
            setActive((a) => ({ ...a, lank: !a.lank }));
            navigate('/game/lank');
          }}
        >
          <div>
            <img src="/assets/images/game/icon_lank.svg" />
            랭킹보기
          </div>
        </LankBtn>
        <StartBtn02
          className={active.start ? 'active' : ''}
          onClick={async () => {
            setActive((a) => ({ ...a, start: !a.start }));
            try {
              const startRes = await GameService.startPlay(parsedGameId);
              const { play_id, player_id } = startRes.data;
              const matchRes = await GameService.getMatch(
                parsedGameId,
                play_id,
                1,
                player_id,
              );

              navigate('/game');
            } catch (e) {
              console.error('[다시하기 에러]', e);
            }
          }}
        >
          <div>
            <img src="/assets/images/game/icon_replay.svg" />
            다시하기
          </div>
        </StartBtn02>
      </BtnWrap>
      <Footer />
      {showLikeModal && selectedIdx !== null && (
        <AddInterestItemModal
          setShowLikeModal={setShowLikeModal}
          selectedIdx={selectedIdx}
          mode="add"
          selectedItem={{
            iidx: selectedIdx,
            group: '',
            group_idx: 0,
            level: 0,
            memo: '',
          }}
          setActiveItem={() => {}}
          checkIsLikeItem={(iidx: number) => toggleLike(iidx, true)}
        />
      )}
      <UserAlert />
    </Container>
  );
};

export default GameResult;

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Inner = styled.div`
  width: 100%;
`;
const Container = styled.div`
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  position: relative;
`;

const TopBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
  margin-top: 40px;
`;

const TopTitle = styled.div`
  color: #000;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 46.4px */
  letter-spacing: -0.4px;
`;

const TopText = styled.div`
  color: #333d4b;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 26.1px */
  letter-spacing: -0.28px;
`;

const CardList = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
  align-self: stretch;
  justify-content: center;
  position: relative;
  padding: 0 12px;
`;

const BottomListWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  align-self: stretch;
  flex-direction: row;
  margin-bottom: 36px;
  width: 100%;
`;
const BottomList = styled.div`
  position: relative;
  width: 100%;
`;

const BottomBox = styled.div`
  border-radius: 20px;
  background: #fff;
  height: 100%;
  bottom: 5px;
  overflow: hidden;
  width: 100%;
`;

const BottomImg = styled.div`
  height: 123px;
  width: 102%;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  > img {
    position: absolute;
    width: 100%;
    top: -3px;
    left: calc(50% - 5px);
    transform: translateX(-50%);
  }
`;

const Imgheart = styled.div`
  display: flex;
  width: 32px;
  height: 32px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  position: absolute;
  right: 4px;
  top: 4px;
  cursor: pointer;
  img {
    width: 16px;
    height: 16px;
  }
`;
const BottomInfo = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding-top: 12px;
  gap: 12px;
  > div:first-child {
    display: flex;
    gap: 16px;
    flex-direction: column;
  }
`;

const BottomInfoTitle = styled.div`
  color: rgba(0, 12, 30, 0.8);

  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
  gap: 2px;
  display: flex;
  flex-direction: column;
  position: relative;
  span {
    color: #008aff;
    font-size: 12px;
    font-weight: 700;
  }
`;
const BottomInfoText = styled.div`
  color: #6b7684;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
`;

const Description = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  flex-direction: column;
`;

const DescriptionInfo = styled.div`
  border-radius: 8px;
  background: #f7f8fc;
  display: flex;
  width: 100%;
  padding: 8px 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  span {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    align-self: stretch;
  }
  span:first-child {
    color: #6b7684;
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    line-height: 150%; /* 21px */
    letter-spacing: -0.28px;
  }
  span:last-child {
    color: #222;
    text-align: center;
    font-family: 'Spoqa Han Sans Neo';
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 145%; /* 26.1px */
    letter-spacing: -0.36px;
  }
`;

const ButtonWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 13px;
  align-self: stretch;
`;

const StartBtn = styled.div`
  display: flex;
  padding: 7px 8px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  align-self: stretch;
  border-radius: 7px;
  background: #e7f0fe;
  color: #008aff;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 19.5px */
  letter-spacing: -0.26px;
`;

const BottomInfoList = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;
`;
const TagWrap = styled.div`
  display: flex;
  align-items: start;
  gap: 6px;
  flex-direction: row;
  align-self: stretch;
  height: auto;
  flex-wrap: wrap;
  min-height: 33px;
  padding-top: 8px;
`;

const TagRed = styled.div`
  display: flex;
  padding: 2px 5px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: #fff0f0;
  color: #f04452;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 19.5px */
  letter-spacing: -0.26px;
`;

const TagBlue = styled.div`
  display: flex;
  padding: 2px 5px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: #e7f0fe;
  color: #008aff;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 19.5px */
  letter-spacing: -0.26px;
`;

const TagGray = styled.div`
  display: flex;
  padding: 2px 5px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border-radius: 4px;
  background: #f4f5f9;
  color: #4e5968;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 19.5px */
  letter-spacing: -0.26px;
`;

const BtnWrap = styled.div`
  background: #f3f4f6;
  display: flex;
  padding: 40px 20px 120px;
  flex-direction: row;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 11px;
`;

const StartBtn02 = styled.div`
  width: 100%;
  height: 46px;
  position: relative;
  cursor: pointer;
  > div {
    border-radius: 12px;
    width: 100%;
    height: 100%;
    flex-direction: row;
    gap: 8px;
    display: inline-flex;
    padding: 16px 20px;
    justify-content: center;
    align-items: center;
    position: absolute;
    color: #6b7684;
    font-family: NanumSquareRoundOTF;
    font-size: 16px;
    font-style: normal;
    font-weight: 800;
    letter-spacing: -0.36px;
    white-space: nowrap;
    position: absolute;
    z-index: 1;
    background: #e6f2fc;
    transition: 0.1s;
    bottom: 0px;
    > img {
      width: 16px;
    }
  }
  &:after {
    width: 100%;
    height: 100%;
    border-radius: 12px;
    background: #bfd0e0;
    display: block;
    content: '';
    position: absolute;
    z-index: 0;
    bottom: -3px;
  }
  &.active {
    > div {
      bottom: -3px;
    }
  }
`;
const LankBtn = styled.div`
  width: 100%;
  height: 46px;
  position: relative;
  cursor: pointer;
  > div {
    border-radius: 12px;
    width: 100%;
    height: 100%;
    flex-direction: row;
    gap: 8px;
    display: inline-flex;
    padding: 16px 20px;
    justify-content: center;
    align-items: center;
    position: absolute;
    color: #6b7684;
    font-family: NanumSquareRoundOTF;
    font-size: 16px;
    font-style: normal;
    font-weight: 800;
    letter-spacing: -0.36px;
    white-space: nowrap;
    position: absolute;
    z-index: 1;
    background: #e6f2fc;
    transition: 0.1s;
    bottom: 0px;
    > img {
      width: 16px;
    }
  }
  &:after {
    width: 100%;
    height: 100%;
    border-radius: 12px;
    background: #bfd0e0;
    display: block;
    content: '';
    position: absolute;
    z-index: 0;
    bottom: -3px;
  }
  &.active {
    > div {
      bottom: -3px;
    }
  }
`;
const ShareBtn = styled.div`
  width: 100%;
  height: 46px;
  position: relative;
  cursor: pointer;
  > div {
    border-radius: 12px;
    width: 100%;
    height: 100%;
    flex-direction: row;
    gap: 8px;
    display: inline-flex;
    padding: 16px 20px;
    justify-content: center;
    align-items: center;
    position: absolute;
    color: #fff;
    font-family: NanumSquareRoundOTF;
    font-size: 16px;
    font-style: normal;
    font-weight: 800;
    letter-spacing: -0.36px;
    white-space: nowrap;
    position: absolute;
    z-index: 1;
    background: #1f7aff;
    transition: 0.1s;
    bottom: 0px;
    > img {
      width: 16px;
    }
  }
  &:after {
    width: 100%;
    height: 100%;
    border-radius: 12px;
    background: #0d538f;
    display: block;
    content: '';
    position: absolute;
    z-index: 0;
    bottom: -3px;
  }
  &.active {
    > div {
      bottom: -3px;
    }
  }
`;
const LoginBtn = styled.div`
  display: flex;
  padding: 5px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 5px;
  background: #e7f0fe;
  color: #008aff;
  text-align: center;

  font-family: 'Spoqa Han Sans Neo';
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;
  cursor: pointer;
`;
